import { routeConstants } from '../../shared/constants';
import ResetPassword from "./";

const route = {
  exact: true,
  path: routeConstants.RESET_PASSWORD.route,
  component: ResetPassword
};

export default route